import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, Fragment } from "react";
import ApplicationReceiptConfirmationForm from "./applicationReceiptConfirmationForm";
export default class ApplicationReceiptConfirmation extends Component {
    render() {
        return (_jsx(Fragment, { children: _jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block clearfix", children: _jsx("h1", { className: "title", children: " Application Receipt Confirmation" }) }), _jsx(ApplicationReceiptConfirmationForm, {})] }) }));
    }
}
